import {
    SET_CURRENT_BUSINESS,
    SET_IS_LOADING,
    SET_IS_MODAL_LOADING,
    SET_IS_MOBILE_MENU_OPEN,
    SET_POPUP,
    SET_LOOKUP_DATA,
    RESET_STORE,
    SET_IS_ADMIN,
    SET_IS_MOBILE_APP,
    SET_MOBILE_APP_WRAPPER_DATA,
    SET_RECAPTCHA,
    SET_PAGE_TYPE,
    SET_T_DATA,
    SET_SETTINGS,
    SET_CONFIG,
    SET_SINGLE_REVIEW_PAGE,
    SET_REVIEWS_PAGE_DATA,
    RESET_REVIEWS_PAGE_DATA,
    SET_IS_MOBILE,
    SET_IS_IPHONE, 
    SET_ADMIN_OTP_LOGIN_TEMP_DATA,
    SET_SELECTED_MONTH_GLOBAL,
    SET_NOTIFICATION,
    SET_OPEN_BIOMETRIC_AS_DEFAULT,
    SET_TZUR_POPUP_CENTER,
    SET_TZUR_POPUP,
    SET_OTP,
    SET_HASH,
    SET_DELIVIARY_ORDERS,
    SET_FROM_LOGINPAGE,
} from "./actionTypes";

const makeActionCreator = (type, ...argNames) => {
    return (...args) => {
        const action = { type };
        argNames.forEach((_, index) => { action[argNames[index]] = args[index]; });
        return action;
    }
};

export const setCurrentBusiness = makeActionCreator(SET_CURRENT_BUSINESS, "payload");

export const setDelivaryOrders = makeActionCreator(SET_DELIVIARY_ORDERS, "payload");
export const setFromLoginPage = makeActionCreator(SET_FROM_LOGINPAGE, "payload");

export const setIsModalLoading = makeActionCreator(SET_IS_MODAL_LOADING, "payload");

export const setOtp = makeActionCreator(SET_OTP, "payload");
export const setHash = makeActionCreator(SET_HASH, "payload");

export const setIsMobileMenuOpen = makeActionCreator(SET_IS_MOBILE_MENU_OPEN, "payload");
export const setIsMobileApp = makeActionCreator(SET_IS_MOBILE_APP, "payload");

export const setIsAdmin = makeActionCreator(SET_IS_ADMIN, "payload");

export const setMobileAppWrapperData = makeActionCreator(SET_MOBILE_APP_WRAPPER_DATA, "payload");

export const setPopup = makeActionCreator(SET_POPUP, "payload");
export const setTzurPopup = makeActionCreator(SET_TZUR_POPUP, "payload");
export const setTzurPopupCenter = makeActionCreator(SET_TZUR_POPUP_CENTER, "payload");
export const setOpenBiometricAsDefault = makeActionCreator(SET_OPEN_BIOMETRIC_AS_DEFAULT, "payload");
export const setNotification = makeActionCreator(SET_NOTIFICATION, "payload");
export const setLookupData = makeActionCreator(SET_LOOKUP_DATA, "payload");
export const resetStore = makeActionCreator(RESET_STORE);
export const setRecaptcha = makeActionCreator(SET_RECAPTCHA, "payload");
export const setPageType = makeActionCreator(SET_PAGE_TYPE, "payload");

export const setIsMobile = makeActionCreator(SET_IS_MOBILE, "payload");
export const setIsIPhone = makeActionCreator(SET_IS_IPHONE, "payload");

export const setAdminOtpLoginTempData = makeActionCreator(SET_ADMIN_OTP_LOGIN_TEMP_DATA, "payload");
export const setSelectedMonthGlobal = makeActionCreator(SET_SELECTED_MONTH_GLOBAL, "payload");

export const setT = makeActionCreator(SET_T_DATA, "payload");
export const setSettings = makeActionCreator(SET_SETTINGS, "payload");
export const setConfig = makeActionCreator(SET_CONFIG, "payload");

export const setSingleReview = makeActionCreator(SET_SINGLE_REVIEW_PAGE, "payload");
export const resetReviewPageData = makeActionCreator(RESET_REVIEWS_PAGE_DATA, "payload");
export const setReviewPageData = makeActionCreator(SET_REVIEWS_PAGE_DATA, "payload");